// extracted by mini-css-extract-plugin
export default {"about_vendor":"Vendor_about_vendor__eB3Ae"};